import React, { useEffect, useRef, useState } from "react";
import { AgentObj } from "../../Models/AgentObj";
import AddAgent from "./add-agent";
import { AddAgentServ, DeleteAgentServ, GetAgentServ, UpdateAgentServ, UploadCsvAgents } from "../../Services/Agent";
import UpdateAgentObj from "../Settings/update-agent-obj";
import { useTranslation } from "react-i18next";
import DeleteButton from "../Settings/delete-button";

const Agents: React.FunctionComponent<{ onChangeMessagehandler: any }> = (props) => {

    const [agentsValue, setAgentsValue] = useState<AgentObj[]>();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [isUpload, setIsUpload] = useState<boolean>(false);
    const [isChange, setIsChange] = useState<boolean>(false);
    const { t } = useTranslation();

    useEffect(() => {
        GetAgentServ().then(resp => {
            setAgentsValue(resp)
        }).catch(error => {
            console.log("error")
        })
    }, [isChange])

    const AddAgentHandler = (agent: any) => {
        return new Promise((resolve, reject) => {
            AddAgentServ(agent).then(resp => {
                setIsChange(!isChange)
                props.onChangeMessagehandler("success", "Agent added successfully !")
                resolve(resp);
            }).catch(error => {
                props.onChangeMessagehandler("error", error.response.data.error);
                reject(error);
            })
        });
    }

    const DropAgent = (id: any) => {
        DeleteAgentServ(id).then(resp => {
            setIsChange(!isChange)
            props.onChangeMessagehandler("success", "Agent deleted successfully !")
        }).catch(error => {
            props.onChangeMessagehandler("error", "Failed to delete agent.");
        })
    }

    const UpdateAgent = (id: any, obj: any) => {
        return new Promise((resolve, reject) => {
            UpdateAgentServ(id, obj).then(resp => {
                setIsChange(!isChange)
                resolve(resp);
                props.onChangeMessagehandler("success", "Agent updated successfully !")
            }).catch(error => {
                reject(error);
                props.onChangeMessagehandler("error", error.response.data.error);
            })
        })
    }

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        UploadCsvAgents(file).then(resp => {
            setIsChange(!isChange)
            setIsUpload(false)
            props.onChangeMessagehandler("success", "Agents added successfully !")
        }).catch(error => {
            props.onChangeMessagehandler("error", error.response.data.error);
        })
    }

    const DownloadTemplate = () => {
        const data = [
            ["Full Name", "Phone Number", "Email", "Languages"]
        ];

        const csvContent = data.map(row => row.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute("download", "template.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    }

    return (
        <>

            <div className="d-flex justify-content-between  align-items-center mb-4">
                <div className="manager-header">
                    <h2 className="manager-title">{t("home.agents")}</h2>
                </div>
                <div className="d-flex">
                    <button
                        className="button-dash back-746AFF color-FFFFFF  border-746AFF padd-15 marg-right-16"
                        onClick={DownloadTemplate}>
                        <svg width="15" height="14" className="size-20" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.7109 14.0273H3.28906C2.54962 14.0265 1.84072 13.7323 1.31786 13.2095C0.794994 12.6866 0.500868 11.9777 0.5 11.2383V2.81641C0.500868 2.07697 0.794994 1.36806 1.31786 0.8452C1.84072 0.322338 2.54962 0.0282121 3.28906 0.0273438H11.7109C12.4504 0.0282121 13.1593 0.322338 13.6821 0.8452C14.205 1.36806 14.4991 2.07697 14.5 2.81641V11.2383C14.4991 11.9777 14.205 12.6866 13.6821 13.2095C13.1593 13.7323 12.4504 14.0265 11.7109 14.0273ZM3.28906 1.12109C2.83959 1.1216 2.40868 1.30038 2.09086 1.6182C1.77303 1.93602 1.59426 2.36694 1.59375 2.81641V11.2383C1.59426 11.6878 1.77303 12.1187 2.09086 12.4365C2.40868 12.7543 2.83959 12.9331 3.28906 12.9336H11.7109C12.1604 12.9331 12.5913 12.7543 12.9091 12.4365C13.227 12.1187 13.4057 11.6878 13.4062 11.2383V2.81641C13.4057 2.36694 13.227 1.93602 12.9091 1.6182C12.5913 1.30038 12.1604 1.1216 11.7109 1.12109H3.28906Z" fill="white" />
                            <path d="M7.5 8.89625C7.35496 8.89625 7.21586 8.83863 7.1133 8.73607C7.01074 8.63352 6.95312 8.49442 6.95312 8.34937V3.26563C6.95312 3.12058 7.01074 2.98148 7.1133 2.87893C7.21586 2.77637 7.35496 2.71875 7.5 2.71875C7.64504 2.71875 7.78414 2.77637 7.8867 2.87893C7.98926 2.98148 8.04688 3.12058 8.04688 3.26563V8.34937C8.04688 8.49442 7.98926 8.63352 7.8867 8.73607C7.78414 8.83863 7.64504 8.89625 7.5 8.89625Z" fill="white" />
                            <path d="M7.49996 9.28661C7.37856 9.28698 7.2583 9.26327 7.14612 9.21685C7.03395 9.17043 6.93209 9.10223 6.84645 9.01619L4.72566 6.89568C4.62308 6.7931 4.56546 6.65397 4.56546 6.5089C4.56546 6.36383 4.62308 6.2247 4.72566 6.12212C4.82824 6.01954 4.96737 5.96191 5.11244 5.96191C5.25751 5.96191 5.39664 6.01954 5.49922 6.12212L7.49996 8.12314L9.5007 6.12212C9.60328 6.01954 9.74241 5.96191 9.88748 5.96191C10.0326 5.96191 10.1717 6.01954 10.2743 6.12212C10.3768 6.2247 10.4345 6.36383 10.4345 6.5089C10.4345 6.65397 10.3768 6.7931 10.2743 6.89568L8.15348 9.01619C8.06783 9.10223 7.96598 9.17043 7.8538 9.21685C7.74163 9.26327 7.62136 9.28698 7.49996 9.28661ZM9.88762 11.2811H5.1123C4.96726 11.2811 4.82816 11.2235 4.72561 11.1209C4.62305 11.0183 4.56543 10.8792 4.56543 10.7342C4.56543 10.5892 4.62305 10.4501 4.72561 10.3475C4.82816 10.2449 4.96726 10.1873 5.1123 10.1873H9.88762C10.0327 10.1873 10.1718 10.2449 10.2743 10.3475C10.3769 10.4501 10.4345 10.5892 10.4345 10.7342C10.4345 10.8792 10.3769 11.0183 10.2743 11.1209C10.1718 11.2235 10.0327 11.2811 9.88762 11.2811Z" fill="white" />
                        </svg>
                        <span className="display-none-mb"> {t("settings.downloadTemplate")}</span>
                    </button>
                    <div>
                        <button
                            className="button-dash border-746AFF color-746AFF back-trans padd-15 marg-right-16"
                            onClick={() => fileInputRef.current?.click()}>
                            <svg width="50" height="50" viewBox="0 0 50 50" className="size-20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_1121_4751)">
                                    <path d="M8.33334 35.417V39.5837C8.33334 40.6887 8.77233 41.7485 9.55373 42.5299C10.3351 43.3113 11.3949 43.7503 12.5 43.7503H37.5C38.6051 43.7503 39.6649 43.3113 40.4463 42.5299C41.2277 41.7485 41.6667 40.6887 41.6667 39.5837V35.417" stroke="#6366F1" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M8.33334 35.417V39.5837C8.33334 40.6887 8.77233 41.7485 9.55373 42.5299C10.3351 43.3113 11.3949 43.7503 12.5 43.7503H37.5C38.6051 43.7503 39.6649 43.3113 40.4463 42.5299C41.2277 41.7485 41.6667 40.6887 41.6667 39.5837V35.417" stroke="black" stroke-opacity="0.2" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M14.5833 18.7497L25 8.33301L35.4167 18.7497" stroke="#6366F1" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M14.5833 18.7497L25 8.33301L35.4167 18.7497" stroke="black" stroke-opacity="0.2" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M25 8.33301V33.333" stroke="#6366F1" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M25 8.33301V33.333" stroke="black" stroke-opacity="0.2" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1121_4751">
                                        <rect width="50" height="50" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <span className="display-none-mb"> {t("settings.uploadAgents")}</span>
                            {isUpload && <div className="spinner-border size-20 text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>}
                        </button>
                        <input
                            type="file"
                            accept=".csv"
                            ref={fileInputRef}
                            onChange={handleFileUpload}
                            style={{ display: "none" }}
                        />
                    </div>
                    <AddAgent onAddAgent={AddAgentHandler} />
                </div>
            </div>
            <div className="table-responsive text-nowrap ">
                <table className="table" >
                    <thead className="table-thead">
                        <tr>
                            <th>{t("propertiesPage.image")}</th>
                            <th>{t("propertyDetails.fullName")}</th>
                            <th>{t("propertyDetails.emailAddress")}</th>
                            <th>{t("propertyDetails.phoneNumber")}</th>
                            <th>{t("propertyDetails.languages")}</th>
                            <th>{t("users.actions")}</th>
                        </tr>
                    </thead>
                    <tbody className="table-tbody">
                        {agentsValue && agentsValue.map((agent: any, index: any) => {
                            return <tr key={"line_" + index}>
                                <td>
                                    <img src={agent.image && agent.image.trim() !== "" ? agent.image : "/assets/images/icons/logo-user.png"} className="border-50 border-D1D5DB size-50" />
                                </td>
                                <td>
                                    {agent.fullName.charAt(0).toUpperCase() + agent.fullName.slice(1)}
                                </td>
                                <td>
                                    {agent.email ? agent.email : ""}
                                </td>
                                <td>
                                    {agent.phoneNumber ? agent.phoneNumber : ""}
                                </td>
                                <td>
                                    {agent.languages ? agent.languages.map((s: any) => s.charAt(0).toUpperCase() + s.slice(1)).join(', ') : ""}
                                </td>
                                <td>
                                    <UpdateAgentObj agent={agent} onUpdateAgent={UpdateAgent} />
                                    <DeleteButton Id={agent._id} onDelete={DropAgent} className="btn p-0  hide-arrow marg-left-10" text="Are you sure you want to delete this User?" />

                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
                {agentsValue && agentsValue.length == 0 && <h3 className="empty">{t("settings.noAgents")}</h3>}
            </div>
        </>

    )
}
export default Agents
